/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AuthenticationMethodEnum {
    PASSWORD = 'PASSWORD',
    MAGIC_LINK = 'MAGIC_LINK',
    AZURE_SSO = 'AZURE_SSO',
    OIDC = 'OIDC',
}
